import { css } from '@emotion/css';
import React, { ButtonHTMLAttributes } from 'react';
import { Loading } from '../Loading';

type FormalConfirmButtonProps = {
  isDisabled?: boolean;
  isLoading?: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const FormalConfirmButton = ({
  children,
  isDisabled,
  isLoading,
  ...rest
}: FormalConfirmButtonProps) => {
  return (
    <button
      className={css`
        width: 100%;
        height: 56px;
        color: ${isDisabled ? '#8f8c85' : 'white'};
        background: ${isDisabled ? '#cdc7bb' : '#14c5b6'};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        border-radius: 28px;
        transition: transform 0.1s cubic-bezier(0.17, 0.89, 0.32, 1.49), background-color 0.1s;
        &:disabled {
          pointer-events: none;
        }
        &:active {
          transform: scale(0.98, 0.95);
        }
      `}
      disabled={isDisabled || isLoading}
      {...rest}
    >
      {isLoading ? <Loading color="white" /> : children}
    </button>
  );
};
